import { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Styles from "./CustomerCartList.module.css";
import { TabTitle } from "../../../Utility/TabTitle";
import emptyImg from "../../../Assets/no_image.svg";
import del from "../../../Assets/delete.svg";
import closeIcon from "../../../Assets/close.svg";
import barcodeScannerIcon from "../../../Assets/barcode_scanner_black.svg";
import Header from "../../../SharedComponents/Header/Header";
import toast from "react-hot-toast";
import BarcodeScannerModal from "../../../Modal/BarcodeScannerModal.tsx";

export default function CustomerCartList() {
  TabTitle("KSTORE - Add-to-cart");
  let navigate = useNavigate();
  let { state, pathname } = useLocation();
  const [cartData, setCartData] = useState([]);
  const [readmoreId, setReadmoreId] = useState("");
  const [isOpenBarcodeScanner, setisOpenBarcodeScanner] = useState(false);
  // const [isShowBarcodeScannerButton, setisShowBarcodeScannerButton] =
  //   useState(false);

  useEffect(() => {
    const session = sessionStorage.getItem("customer_cart_list");
    // const scrollerStr = sessionStorage.getItem("scroller_data");
    // if (scrollerStr) {
    //   const parsed = JSON.parse(scrollerStr);
    //   setisShowBarcodeScannerButton(parsed?.is_barcode_enabled === 1);
    // }
    if (session === null) {
      setCartData(state?.selectedItems);
    } else {
      setCartData(JSON.parse(session));
    }
  }, []);

  const handleCartTotal = () => {
    if (cartData?.length === 0) {
      return 0;
    }
    const totalAmount = cartData?.reduce((previousValue, currentValue) => {
      return (
        previousValue +
        (currentValue?.selectedUnit
          ? currentValue?.selectedUnit.total_amount
          : currentValue.total_amount)
      );
    }, 0);
    return totalAmount;
  };

  const handleCartCount = (price, id, qty, index, product) => {
    const count_amount = price * qty;
    let refData = [...cartData];

    if (product?.selectedUnit?.id) {
      refData[index].selectedUnit.qty = qty;
      refData[index].selectedUnit.total_amount = count_amount;
    } else {
      refData[index].qty = qty;
      refData[index].total_amount = count_amount;
    }

    setCartData(refData);
    sessionStorage.setItem("customer_cart_list", JSON.stringify(refData));
  };

  const handleOnChangeQty = (cartItem, index, value) => {
    const minQty = cartItem?.selectedUnit?.id
      ? cartItem?.selectedUnit?.min_quantity || 1
      : cartItem?.min_quantity || 1;

    const maxQty = cartItem?.selectedUnit?.id
      ? cartItem?.selectedUnit?.quantity
      : cartItem?.quantity;

    // Allow empty while typing
    if (value === "") {
      let refData = [...cartData];

      if (cartItem?.selectedUnit?.id) {
        refData[index].selectedUnit.qty = "";
      } else {
        refData[index].qty = "";
      }

      setCartData(refData);
      return;
    }

    const qty = Number(value);

    if (isNaN(qty)) return;

    // Only update cart when valid
    if (qty >= minQty && qty <= maxQty) {
      handleCartCount(
        cartItem?.selectedUnit?.id
          ? cartItem?.selectedUnit?.selling_price
          : cartItem?.selling_price,
        cartItem?.product_id,
        qty,
        index,
        cartItem,
      );
    } else {
      if (qty < minQty) {
        toast.error(`Minimum quantity is ${minQty}`, { type: "error" });
      } else if (qty > maxQty) {
        toast.error(`Maximum quantity is ${maxQty}`, { type: "error" });
      }
    }
  };

  const handleOnBlurQty = (cartItem, index) => {
    const minQty = cartItem?.selectedUnit?.id
      ? cartItem?.selectedUnit?.min_quantity || 1
      : cartItem?.min_quantity || 1;

    const maxQty = cartItem?.selectedUnit?.id
      ? cartItem?.selectedUnit?.quantity
      : cartItem?.quantity;

    let qty = Number(
      cartItem?.selectedUnit?.id ? cartItem?.selectedUnit?.qty : cartItem?.qty,
    );

    if (qty < minQty) qty = minQty;
    if (qty > maxQty) qty = maxQty;

    handleCartCount(
      cartItem?.selectedUnit?.id
        ? cartItem?.selectedUnit?.selling_price
        : cartItem?.selling_price,
      cartItem?.product_id,
      qty,
      index,
      cartItem,
    );
  };

  const handleClearCart = () => {
    setCartData([]);
  };

  const handleClearProduct = (item) => {
    let filterCartList = cartData?.filter((val) =>
      val?.product_id === item?.product_id
        ? val?.selectedUnit?.unit_id !== item?.selectedUnit?.unit_id
        : val?.product_id !== item?.product_id,
    );
    setCartData(filterCartList);
    sessionStorage.setItem(
      "customer_cart_list",
      JSON.stringify(filterCartList),
    );
  };

  // const handleAddBarcodeProductToCart = (data) => {
  //   let cartProductsList = [];
  //   const str = sessionStorage.getItem("customer_cart_list");
  //   if (str) {
  //     cartProductsList = JSON.parse(str) ?? [];
  //   }

  //   let isAlreadyExist = cartProductsList?.find(
  //     (e) => e?.product_id === data?.product_id && !e.selectedUnit?.unit_id,
  //   )
  //     ? true
  //     : false;

  //   if (isAlreadyExist) {
  //     let filterData = [...cartProductsList].filter((e) => {
  //       return e.product_id === data.product_id
  //         ? e.selectedUnit?.unit_id !== data?.selectedUnit?.unit_id
  //         : e.product_id !== data.product_id;
  //     });
  //     setcustomerSelectedItem(filterData);
  //   } else {
  //     cartProductsList = [
  //       ...cartProductsList,
  //       { ...data, total_amount: data?.selling_price * data?.qty },
  //     ];
  //   }

  //   sessionStorage.setItem(
  //     "customer_cart_list",
  //     JSON.stringify(cartProductsList),
  //   );
  // };

  return (
    <>
      <Header />
      <div className={Styles.bg}>
        <div className="bg-white">
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ marginBottom: "15px" }}
          >
            <h1 className={Styles.title + " mb-0"}>
              Cart <span className="orange">List</span>{" "}
            </h1>
            {/* {isShowBarcodeScannerButton && (
              <img
                width="25px"
                src={barcodeScannerIcon}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setisOpenBarcodeScanner(true);
                }}
              />
            )} */}
          </div>
          <div className={Styles.overallcart}>
            <div className={Styles.leftTable}>
              <div className={Styles.mobileCart + " d-block d-sm-none"}>
                {cartData &&
                  cartData?.map((e, index) => (
                    <div className={Styles.item} key={index.toString()}>
                      <img
                        className={Styles.productImg}
                        alt="cart"
                        src={
                          e?.product_images[0]?.image?.length
                            ? e?.product_images[0]?.image[0]
                            : emptyImg
                        }
                      />
                      <div className={Styles.itemContent}>
                        <div className={Styles.itemHeader}>
                          <p className={Styles.title}>
                            {readmoreId === e?.customer_wishlist_id
                              ? e?.product_name
                              : e?.product_name.substring(0, 37)}
                            {e?.product_name.length > 37 &&
                              readmoreId !== e?.customer_wishlist_id && (
                                <span
                                  className={Styles.readmore + " orange cp"}
                                  onClick={() =>
                                    setReadmoreId(e.customer_wishlist_id)
                                  }
                                >
                                  ... Read More
                                </span>
                              )}
                          </p>
                          <img
                            className={Styles.clsicon}
                            width="14px"
                            src={closeIcon}
                            onClick={() => handleClearProduct(e)}
                            style={{ cursor: "pointer" }}
                            alt="close"
                          />
                        </div>

                        {(e.colorItem || e.selectedUnit) && (
                          <div className={Styles.unitColor}>
                            {e.selectedUnit && (
                              <span className={Styles.unitColorText}>
                                Unit : {e.selectedUnit.unit_id}
                              </span>
                            )}
                            {e.colorItem && (
                              <span className={Styles.unitColorText}>
                                Color : {e.colorItem.name}
                              </span>
                            )}
                          </div>
                        )}

                        <div className={Styles.itemFooter}>
                          <div className={Styles.quantityWrapper}>
                            <input
                              className={Styles.productCount}
                              type="number"
                              value={
                                e?.selectedUnit?.id
                                  ? e?.selectedUnit?.qty
                                  : e?.qty
                              }
                              min={
                                e?.selectedUnit?.id
                                  ? e?.selectedUnit?.min_quantity || 1
                                  : e?.min_quantity || 1
                              }
                              onChange={(userCount) => {
                                handleOnChangeQty(
                                  e,
                                  index,
                                  userCount.target.value,
                                );
                              }}
                              onBlur={() => {
                                handleOnBlurQty(e, index);
                              }}
                            />
                            <span className={Styles.confirmQtyNote}>
                              Confirm Qty
                            </span>
                          </div>

                          {(e?.selectedUnit?.id
                            ? (e?.selectedUnit?.selling_price || 0) * (e?.selectedUnit?.qty || 1)
                            : (e?.selling_price || 0) * (e?.qty || 1)) > 0 ? (
                            <p className={Styles.price}>
                              <span className="currency_symbol">₹</span>{" "}
                              {e?.selectedUnit?.id
                                ? e?.selectedUnit?.total_amount ||
                                  (e?.selectedUnit?.selling_price || 0) *
                                    (e?.selectedUnit?.qty || 1)
                                : e?.total_amount ||
                                  (e?.selling_price || 0) * (e?.qty || 1)}
                            </p>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  ))}
                {cartData?.length === 0 ? (
                  <p className="fs-6 text-center text-secondary p-3">
                    Data Not Found
                  </p>
                ) : null}
              </div>

              <div
                className={
                  Styles.table +
                  " table-responsive d-none d-sm-block customerCart justify-content-center"
                }
              >
                <table>
                  <thead>
                    <tr>
                      <th className={Styles.th + " text-center"}>S.No</th>
                      <th className={Styles.cartProductName + ""}>
                        Product Name
                      </th>
                      <th className={Styles.th + " text-center"}>Color</th>
                      <th className={Styles.th + " text-center"}>Unit</th>
                      <th className={Styles.th + " text-center"}>Quantity</th>
                      <th className={Styles.th + " text-center"}>Price</th>
                      <th className={Styles.cartList + " text-center"}>
                        Total
                      </th>
                      <th className={Styles.cartList + " text-center"}>
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {cartData?.map((e, index) => (
                      <tr key={e.product_id} className={Styles.tr}>
                        <td className="text-center">{index + 1}</td>
                        <td
                          className={Styles.productContainer + " contentFont"}
                        >
                          <div className={Styles.imgContainer}>
                            <img
                              className={Styles.img}
                              src={
                                e?.product_images[0]?.image?.length
                                ? e?.product_images[0]?.image[0]
                                : emptyImg
                              }
                              alt="cart"
                            />
                          </div>
                          <p className={Styles.productDetails + " mb-0 "}>
                            {readmoreId === e.customer_wishlist_id
                              ? e.product_name
                              : e.product_name.substring(0, 37)}
                            <span
                              style={{
                                display:
                                  e.product_name.length < 37 ||
                                    readmoreId === e.customer_wishlist_id
                                    ? "none"
                                    : "block",
                              }}
                              className={Styles.readmore + " orange cp"}
                              onClick={() =>
                                setReadmoreId(e.customer_wishlist_id)
                              }
                            >
                              Read More
                            </span>
                          </p>
                        </td>
                        <td className="text-center contentFont">
                          <p className={Styles.productDetails + " mb-0 "}>
                            {e.colorItem ? e.colorItem.name : ""}
                          </p>
                        </td>
                        <td className="text-center contentFont">
                          <p className={Styles.productDetails + " mb-0 "}>
                            {e.selectedUnit ? e.selectedUnit.unit_id : ""}
                          </p>
                        </td>

                        <td className="text-center contentFont">
                          <input
                            className={Styles.productCount}
                            type="number"
                            value={
                              e?.selectedUnit?.id
                                ? e?.selectedUnit?.qty
                                : e?.qty
                            }
                            min={
                              e?.selectedUnit?.id
                                ? e?.selectedUnit?.min_quantity || 1
                                : e?.min_quantity || 1
                            }
                            onChange={(userCount) => {
                              handleOnChangeQty(
                                e,
                                index,
                                userCount.target.value,
                              );
                            }}
                            onBlur={() => {
                              handleOnBlurQty(e, index);
                            }}
                          />
                          <div className={Styles.confirmQtyNote}>
                            Confirm Qty
                          </div>
                        </td>
                        <td className="contentFont text-center">
                          {(e?.selectedUnit?.id
                            ? e?.selectedUnit?.selling_price || 0
                            : e?.selling_price || 0) > 0
                            ? "₹" +
                              (e?.selectedUnit?.id
                                ? e?.selectedUnit?.selling_price || 0
                                : e?.selling_price || 0)
                            : "-"}
                        </td>
                        <td
                          className={
                            Styles.td + " orange contentFont text-center"
                          }
                        >
                          {(e?.selectedUnit?.id
                            ? e?.selectedUnit?.total_amount || 0
                            : e.total_amount || 0) > 0
                            ? "₹" +
                              (e?.selectedUnit?.id
                                ? e?.selectedUnit?.total_amount || 0
                                : e.total_amount || 0)
                            : "-"}
                        </td>
                        <td className="text-center">
                          <OverlayTrigger
                            placement="bottom"
                            overlay={<Tooltip>Delete</Tooltip>}
                          >
                            <img
                              className={Styles.del}
                              src={del}
                              onClick={() => handleClearProduct(e)}
                              alt="del"
                            />
                          </OverlayTrigger>
                        </td>
                      </tr>
                    ))}
                    {cartData?.length === 0 ? (
                      <tr>
                        <td
                          colSpan={7}
                          className="fs-6 text-center text-secondary p-3"
                        >
                          Data Not Found
                        </td>
                      </tr>
                    ) : null}
                  </tbody>
                </table>
              </div>

              <div
                style={{
                  display: pathname.includes("/kansas_product") ? "none" : null,
                }}
                className={Styles.cartBtnContainer + " mt-3"}
              >
                {cartData?.length > 0 ? (
                  <div className={Styles.cartBtnLeftContainer}>
                    <button
                      onClick={handleClearCart}
                      className={Styles.clearCart + " text-uppercase"}
                    >
                      Clear Cart
                    </button>
                  </div>
                ) : null}
              </div>
            </div>

            <div className={Styles.rightCart}>
              <div className={Styles.mblCartotal}>
                <p className="kstoreFont">Cart Total</p>
                <div className={Styles.totalDetailsContainer}>
                  <div
                    className={
                      Styles.priceDiv + " d-flex justify-content-between"
                    }
                  >
                    <span className={Styles.font}>Sub Total </span>
                    <span className={Styles.font}>
                      ₹{handleCartTotal(cartData)?.toFixed(2)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between ">
                    <span className={Styles.font}>Total </span>
                    <span className={Styles.font}>
                      ₹{handleCartTotal(cartData)?.toFixed(2)}
                    </span>
                  </div>
                </div>
                <button
                  className={Styles.checkoutBtn}
                  style={
                    cartData?.length === 0
                      ? { cursor: "default", backgroundColor: "#AC5701" }
                      : { cursor: "pointer", backgroundColor: "#F27F0C" }
                  }
                  disabled={cartData?.length === 0}
                  onClick={() => {
                    if (
                      handleCartTotal(cartData)?.toFixed(2) >=
                      state?.minimumOrderValue
                    ) {
                      navigate("/kansas_product/checkout", {
                        replace: true,
                        state: { items: cartData, customerStatus: 1 },
                      });
                      sessionStorage.setItem(
                        "customer_cart_list",
                        JSON.stringify(cartData),
                      );
                    } else {
                      toast.success(
                        `Minimum order value is ${state?.minimumOrderValue}`,
                      );
                    }
                  }}
                >
                  Proceed to Checkout
                </button>
                <button
                  className={Styles.backBtn}
                  onClick={() => navigate(-1)}
                >
                  Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
